package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsPt : Strings {
  override val locale: String = "pt"

  override val header_menu_home: String = "Home"

  override val header_menu_about: String = "Sobre"

  override val header_menu_download: String = "Download"

  override val header_menu_contact: String = "Contato"

  override val header_toggle_color_mode: String = "Alternar modo de cor"

  override val hero_title: String = "Poses incríveis para fotos inesquecíveis"

  override val hero_description: String =
      "Aqui você encontra a inspiração que precisa! Seja para usar no Instagram, compartilhar com amigos ou mesmo profissionamente."

  override val about_title: String = "Te ajudamos a encontrar a pose perfeita para sua foto!"

  override val about_description_1: String =
      "Sempre bate aquela dúvida na hora de fazer uma pose para uma foto, não é mesmo?"

  override val about_description_2: String =
      "Com o ProPoses você tem na palma da sua mão uma variedade enorme de sugestões para cada ocasião."

  override val download_title: String = "Baixe o ProPoses app agora!"

  override val download_description: String =
      "Clique na sua loja de aplicativos abaixo para ser direcionado e faça o download do app"

  override val download_google_play: String = "Baixe na Google Play"

  override val download_app_store: String = "Baixe na App Store"

  override val contact_title: String = "Precisa falar conosco?"

  override val contact_description: String =
      "Se você possui alguma dúvida, sugestão ou algum pedido, envie-nos uma mensagem para o endereço "

  override val terms_of_use: String = "Termos de uso"

  override val privacy_policy: String = "Política de Privacidade"

  override val copyright: String = "Copyright © 2024 ProPoses. Todos os direitos reservados"

  override val terms_screen_title: String = "Termos de uso"

  override val terms_screen_description: String = """
      |
      |        Este Termo de Uso ("Termo") estabelece os termos e condições sob os quais você ("Usuário") pode acessar e utilizar o aplicativo ProPoses ("Aplicativo"). Ao acessar ou utilizar o Aplicativo, você concorda em cumprir integralmente os termos deste documento.
      |    
      """.trimMargin()

  override val terms_screen_item_1: String = "1. Definições"

  override val terms_screen_item_1_1_text: String = """
      |
      |        Aplicativo: Refere-se ao aplicativo móvel ProPoses e a todos os seus serviços, funcionalidades e conteúdos.
      |    
      """.trimMargin()

  override val terms_screen_item_1_2_text: String = """
      |
      |        Usuário: Refere-se a qualquer pessoa que acessa ou utiliza o Aplicativo.
      |    
      """.trimMargin()

  override val terms_screen_item_1_3_text: String = """
      |
      |        Conteúdo: Refere-se a qualquer informação, dados, texto, software, fotografias, gráficos, mensagens, tags, comentários ou outro material que seja publicado no Aplicativo.
      |    
      """.trimMargin()

  override val terms_screen_item_2: String = "2. Registro e Conta"

  override val terms_screen_item_2_1_text: String = """
      |
      |        Para criar suas próprias coleções de poses no Aplicativo, você precisa entrar com sua conta Google. Assim não precisa criar uma conta específica para nosso Aplicativo e nem uma nova senha.
      |    
      """.trimMargin()

  override val terms_screen_item_3: String = "3. Uso do Aplicativo"

  override val terms_screen_item_3_1_text: String = """
      |
      |        O Aplicativo permite que você busque por poses para fotos, salve suas poses favoritas e compartilhe o Aplicativo com outras pessoas. Você concorda em utilizar o Aplicativo apenas para fins lícitos e de acordo com estes Termos.
      |    
      """.trimMargin()

  override val terms_screen_item_4: String = "4. Conteúdo Gerado pelo Usuário"

  override val terms_screen_item_4_1_text: String = """
      |
      |        Ao publicar qualquer Conteúdo no Aplicativo, você concede ao Aplicativo uma licença mundial, não exclusiva, gratuita, irrevogável e sublicenciável para usar, copiar, modificar, adaptar, publicar, traduzir, criar trabalhos derivados, distribuir, executar e exibir tal Conteúdo em qualquer mídia existente ou futura. Você declara e garante que possui todos os direitos sobre o Conteúdo publicado e que tal Conteúdo não viola nenhum direito de terceiros.
      |    
      """.trimMargin()

  override val terms_screen_item_5: String = "5. Proibições"

  override val terms_screen_item_5_1_text: String = """
      |
      |        Você não pode:
      |    
      """.trimMargin()

  override val terms_screen_item_5_2_text: String = """
      |
      |        - Publicar qualquer Conteúdo que seja difamatório, obsceno, ofensivo, ilegal, invasivo da privacidade de terceiros ou que infrinja qualquer direito de propriedade intelectual de terceiros.
      |    
      """.trimMargin()

  override val terms_screen_item_5_3_text: String = """
      |
      |        - Interferir ou tentar interferir no funcionamento adequado do Aplicativo.
      |    
      """.trimMargin()

  override val terms_screen_item_5_4_text: String = """
      |
      |        - Utilizar qualquer dispositivo, software ou rotina para interferir ou tentar interferir no funcionamento adequado do Aplicativo.
      |    
      """.trimMargin()

  override val terms_screen_item_6: String = "6. Propriedade Intelectual"

  override val terms_screen_item_6_1_text: String = """
      |
      |        Todos os direitos, títulos e interesses no Aplicativo e em todo o seu conteúdo são de propriedade do time ProPoses ou de seus licenciadores.
      |    
      """.trimMargin()

  override val terms_screen_item_7: String = "7. Isenção de Responsabilidade"

  override val terms_screen_item_7_1_text: String = """
      |
      |        O Aplicativo é fornecido "como está" e "conforme disponível". A ProPoses não garante que o Aplicativo esteja livre de erros ou que funcionará sem interrupções. Em nenhuma circunstância a ProPoses será responsável por quaisquer danos diretos, indiretos, incidentais, especiais, consequenciais ou punitivos decorrentes do uso ou da incapacidade de usar o Aplicativo.
      |    
      """.trimMargin()

  override val terms_screen_item_8: String = "8. Alterações"

  override val terms_screen_item_8_1_text: String = """
      |
      |        A ProPoses reserva-se o direito de modificar estes Termos a qualquer momento. As alterações entrarão em vigor imediatamente após a sua publicação no Aplicativo.
      |    
      """.trimMargin()

  override val terms_screen_item_9: String = "9. Lei Aplicável e Jurisdição"

  override val terms_screen_item_9_1_text: String = """
      |
      |        Este Termo será regido e interpretado de acordo com as leis do Brasil. Qualquer disputa decorrente deste Termo será submetida à jurisdição exclusiva dos tribunais do Brasil.
      |    
      """.trimMargin()

  override val privacy_screen_title: String = "Política de Privacidade"

  override val privacy_screen_description: String = """
      |
      |        A sua privacidade é importante para nós. É política da ProPoses respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar em nosso aplicativo.
      |    
      """.trimMargin()

  override val privacy_screen_item_1: String = "1. Informações gerais"

  override val privacy_screen_item_1_1_text: String = """
      |
      |        Nesta política de privacidade será informada a maneira que ocorre o tratamento dos dados pessoais das pessoas que acessam o app ProPoses informando assim, de forma transparente quais são os dados, qual o intuito da coleta e a maneira que os usuários podem controlar ou deletar suas informações.
      |    
      """.trimMargin()

  override val privacy_screen_item_1_2_text: String = """
      |
      |        Este texto foi criado de acordo com a lei de Proteção de Dados Pessoais (Lei /18), o Marco Civil da Internet  (Lei 12.965 /14) e também o Regulamento da UE n. 2016/6790. Vale ressaltar que, este texto poderá sofrer alterações por conta de eventuais atualizações normativas.
      |    
      """.trimMargin()

  override val privacy_screen_item_1_3_text: String = """
      |
      |        Informamos que toda e qualquer informação pessoal coletada por nosso app será utilizada para melhorar a sua experiência ao usar o mesmo, visando desta maneira que se torne mais vantajosa e assertiva.
      |    
      """.trimMargin()

  override val privacy_screen_item_2: String = "2. Coleta de dados"

  override val privacy_screen_item_2_1_text: String = """
      |
      |        Os dados pessoais são coletados quando a pessoa realiza o login no aplicativo e com base nisso são coletados seu nome e e-mail.
      |    
      """.trimMargin()

  override val privacy_screen_item_2_2_text: String = """
      |
      |        O login no aplicativo é feito através da conta Google da pessoa, a fim de prover mais segurança e evitar que seja necessário criar uma conta/senha em nosso aplicativo.
      |    
      """.trimMargin()

  override val privacy_screen_item_2_3_text: String = """
      |
      |        O login é necessário apenas para as pessoas que desejam criar suas próprias coleções de poses, pois dessa forma nosso sistema conseguirá associar apenas os itens escolhidos por cada pessoa.
      |    
      """.trimMargin()

  override val privacy_screen_item_3: String = "3. Aceite"

  override val privacy_screen_item_3_1_text: String = """
      |
      |        A partir do momento da utilização do aplicativo ProPoses, pressupõe que o usuário aceitou a política de privacidade. Desta forma reservamos-nos ao direito de modificar esta política sem que seja realizado um aviso prévio. Por este motivo, nós recomendamos que os usuários realizem uma consulta regularmente a nossa política, para que desta forma, se mantenham sempre atualizados de possíveis alterações.
      |    
      """.trimMargin()

  override val privacy_screen_item_4: String = "4. Alterações na Política de Privacidade"

  override val privacy_screen_item_4_1_text: String = """
      |
      |        Essa politica de privacidade obteve sua última atualização na data de 19/10/2024, podendo ser modificada a qualquer momento, sem aviso prévio.
      |    
      """.trimMargin()

  override val privacy_screen_item_5: String = "5. Contato"

  override val privacy_screen_item_5_1_text: String = """
      |
      |        Se você tiver alguma dúvida sobre esta Política de Privacidade ou deseja alterar/excluir seus dados, entre em contato conosco através do e-mail proposes@logicalside.com.br.
      |    
      """.trimMargin()
}
